
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/staff-solutions",
      function () {
        return require("private-next-pages/staff-solutions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/staff-solutions"])
      });
    }
  